/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./side-nav.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box, media } from '@atlaskit/primitives/compiled';
import { useMatchMedia } from '../../../common/ui';
var styles = {
  background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
export var SideNav = function SideNav() {
  var isAboveMediumScreen = useMatchMedia(media.above.md);
  return isAboveMediumScreen ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.background
  }, /*#__PURE__*/React.createElement(Image, null)) : null;
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 308,
    height: 705,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 5.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 9,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 17.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 48.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 52.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 60.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 91.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 95.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 103.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 134.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 138,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 146.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 177.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 181,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 189.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 24,
    y: 232.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 263.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.333 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 8,
    x: 44,
    y: 275.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 301h308v404H0V301Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A1BDD9",
    fillOpacity: 0.08,
    d: "M0 302h308v-2H0v2Z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 306.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 310,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 318.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 361.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 365,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 373.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 404.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 408.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 416.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 32,
    x: 13,
    y: 450,
    fill: "#22272B",
    stroke: "#A1BDD9",
    strokeOpacity: 0.08,
    strokeWidth: 1.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 507.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 550.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 279,
    height: 43,
    x: 17,
    y: 576,
    fill: "#1C2B41",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 597.5,
    r: 2,
    fill: "#05C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 61,
    y: 593.5,
    fill: "#05C",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1868DB",
    d: "M17 589h2.66v15.96H17z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 640.5,
    r: 2,
    fill: "#BFDBF8",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 60,
    y: 636.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 683.5,
    r: 2,
    fill: "#BFDBF8",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 60,
    y: 679.5,
    fill: "#454F59",
    rx: 3.99
  }));
};